import React from 'react';

const Team = () => (
  <div className="py-2 bg-white">
    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="lg:text-center mt-6">
        <h3 className="mt-4 text-3xl md:text-5xl leading-20 font-extrabold tracking-tight text-gray-700">
          Meet the team
        </h3>
        <p className="mt-4 max-w-2xl text-xl leading-7 text-gray-500 lg:mx-auto">
          Collectively, we have over 20 years of experience and expertise.
        </p>
      </div>
    </div>

    <div className="mt-8 md:mt-20 md:px-64 max-w-screen-xl mx-auto">
      <ul className="border-none md:grid md:grid-cols-2 md:col-gap-2 md:row-gap-4">
        <li className="list-none -mb-16">
          <div className="flex-shrink-0 pb-2 md:pb-8">
            <img
              src={require('../svg/Team/jason_edited.jpg')}
              alt="Jason"
              class="h-32 w-32 md:h-56 md:w-56 rounded-full mx-auto"
            />
          </div>

          <div className="text-center">
            <h5 className="text-2xl leading-6 font-bold text-primary">Jason Stanard</h5>
            <p className="mt-2 mb-16 lg:mb-0  text-base leading-6 text-gray-500">Owner/Founder</p>
          </div>
        </li>
        <li className="list-none -mb-16">
          <div className="flex-shrink-0 pb-2 pt-8 md:pt-0 md:pb-8">
            <img
              src={require('../svg/Team/lawrence_edited.jpg')}
              alt="Raneshia"
              class="h-32 w-32 md:h-56 md:w-56 rounded-full mx-auto"
            />
          </div>

          <div className="text-center">
            <h5 className="text-2xl leading-6 font-bold text-primary">Raneshia Lawrence</h5>
            <p className="mt-2 text-base leading-6 text-gray-500">Marketing Director</p>
          </div>
        </li>
      </ul>
    </div>
    <div className="md:mt-10 md:pl-20 md:pr-20 max-w-screen-xl mx-auto">
      <ul className="border-none md:grid md:grid-cols-4 md:col-gap-2 md:row-gap-4">
        <li className="list-none -mb-16"></li>
        <li className="list-none -mb-16">
          <div className="flex-shrink-0 pb-2 pt-8 md:pt-0 md:pb-8">
            <img
              src={require('../svg/Team/olivia_edited.jpg')}
              alt="Olivia"
              class="h-32 w-32 md:h-48 md:w-48 rounded-full mx-auto"
            />
          </div>

          <div className="text-center">
            <h5 className="text-2xl leading-6 font-bold text-primary">Olivia Wu</h5>
            <p className="mt-2 mb-16 lg:mb-0 text-base leading-6 text-gray-500">
              Marketing Consultant
            </p>
          </div>
        </li>

        <li className="list-none -mb-16">
          <div className="flex-shrink-0 pb-2 pt-8 md:pt-0 md:pb-8">
            <img
              src={require('../svg/Team/josh_edited.jpg')}
              alt="Josh"
              class="h-32 w-32 md:h-48 md:w-48 rounded-full mx-auto"
            />
          </div>

          <div className="text-center">
            <h5 className="text-2xl leading-6 font-bold text-primary">Josh Sutherland</h5>
            <p className="mt-2 text-base leading-6 text-gray-500">Sr. Web Designer</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
);

export default Team;
